var React = require('react');

function BackendNavigationMta (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#000000","d":"M3.5 7c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zM3.5 1c1.378 0 2.5 1.122 2.5 2.5s-1.122 2.5-2.5 2.5-2.5-1.122-2.5-2.5 1.122-2.5 2.5-2.5z","key":0}),React.createElement("path",{"fill":"#000000","d":"M12.078 3h2.422l-3-3-3 3h2.422c0 0.891-0.25 1.842-0.724 2.748-0.485 0.929-1.207 1.814-2.087 2.562-1.984 1.685-4.654 2.613-7.516 2.613-0.319 0-0.578 0.259-0.578 0.578s0.259 0.578 0.578 0.578c3.136 0 6.072-1.025 8.265-2.887 0.993-0.843 1.81-1.848 2.364-2.907 0.56-1.071 0.856-2.206 0.856-3.284z","key":1}),React.createElement("path",{"fill":"#000000","d":"M13.707 13l2.146-2.146c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-2.146 2.146-2.146-2.146c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l2.146 2.146-2.146 2.146c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l2.146-2.146 2.146 2.146c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-2.146-2.146z","key":2})]);
}

BackendNavigationMta.displayName = "BackendNavigationMta";

BackendNavigationMta.defaultProps = {"version":"1.1","width":"100%","height":"100%","viewBox":"0 0 16 16"};

module.exports = BackendNavigationMta;

BackendNavigationMta.default = BackendNavigationMta;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-navigation-mta.svg
// module id = 993
// module chunks = 0